import { cva } from "class-variance-authority";

export { default as InputDropdown } from "./InputDropdown.vue";
export { default as InputDropdownItem } from "./InputDropdownItem.vue";
export { default as Tags } from "./Tags.vue";
export { default as UserInputDropdown } from "./UserInputDropdown.vue";

export const sizes = ["sm", "md", "lg", "xl", "2xl"];
export const types = ["default", "icon", "avatar", "dot", "tag"];

export const rootVariants = cva(
    [
        "inline-flex",
        "items-center",
        "border",
        "border-primary",
        "rounded-md",
        "flex-nowrap",
        "bg-white",
        "w-full",
        "focus-within:ring-brand-shadow",
        "focus-within:border-brand",
        "font-medium",
    ],
    {
        variants: {
            size: {
                sm: ["text-style-sm", "h-[36px]", "px-3.5", "py-2"],
                md: ["text-style-sm", "h-10", "px-3.5", "py-2"],
                lg: ["text-style-base", "h-11", "px-3.5", "py-2.5"],
                xl: ["text-style-base", "h-12", "px-3.5", "py-2.5"],
                "2xl": ["text-style-lg", "h-14", "px-3.5", "py-2.5"],
            },
        },
        compoundVariants: [
            {
                size: "sm",
                multiple: true,
                class: ["h-fit", "min-h-[36px]"],
            },
            {
                size: "md",
                multiple: true,
                class: ["h-fit", "min-h-[40px]"],
            },
            {
                size: "lg",
                multiple: true,
                class: ["h-fit", "min-h-[44px]"],
            },
            {
                size: "xl",
                multiple: true,
                class: ["h-fit", "min-h-[48px]"],
            },
            {
                size: "2xl",
                multiple: true,
                class: ["h-fit", "min-h-[56px]"],
            },
        ],
    }
);

export const variants = cva([], {
    variants: {
        size: {
            sm: ["text-sm"],
            md: ["text-sm"],
            lg: ["text-base"],
            xl: ["text-base"],
            "2xl": ["text-lg"],
        },
        hideSelected: {
            true: ["data-[state=checked]:!hidden"],
        },
    },
});

export const iconSizes = cva([], {
    variants: {
        size: {
            sm: ["w-3.5", "h-3.5"],
            md: ["w-5", "h-5"],
            lg: ["w-5", "h-5"],
            xl: ["w-5", "h-5"],
            "2xl": ["w-5", "h-5"],
        },
    },
});

export const tagItemVariants = cva(["text-sm"], {
    variants: {
        size: {
            sm: ["py-0.5"],
            md: ["py-0.5"],
            lg: ["py-1"],
            xl: ["py-1"],
            "2xl": ["py-1.5"],
        },
    },
});
